import React from 'react'
import Hero from '../components/Hero'

const About = () => {

  const heading = "About E-com";
  return (
    <div>
      <Hero heading={heading} />
    </div>
  )
}

export default About